import {inject, Injectable, signal} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";
import {ApartmentDto} from "admin-api-dto";
import {BehaviorSubject, map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApartmentService {

  constructor() {
    this.retrieveApartments();
  }

  private readonly http = inject(HttpClient);

  public readonly apartments$ = new BehaviorSubject<ApartmentDto[]>([]);

  private retrieveApartments() {
    this.http.get<ApartmentDto[]>(`${environment.apiUrl}/api/private/apartments`).subscribe(
      value => this.apartments$.next(value)
    )
  }

  public requestLotteryEligibilityExport() {
    return this.http.get<{ s3Key: string }>(`${environment.apiUrl}/api/private/apartments/eligibility-csv`);
  }

  public getLotteryEligibilityDownloadUrl(s3Key: string) {
    return this.http.get<{ url: string }>(`${environment.apiUrl}/api/private/apartments/eligibility-csv/signed`, {
      params: {s3Key}
    });
  }

  public getApartment(id: string) {
    return this.apartments$.pipe(
      map(
        apartments => apartments.find(apartment => apartment.id === id)!
      )
    )
  }

}
